import React from 'react';
import classnames from 'classnames';

export interface TopAppbarFixedAdjustProps {
  tag?: string;
  className?: string;
  dense?: boolean;
  prominent?: boolean;
  short?: boolean;
}

const FixedAdjust: React.FunctionComponent<TopAppbarFixedAdjustProps> = ({
  tag: Tag = 'main',
  children,
  className = '',
  dense = false,
  prominent = false,
  short = false,
  ...otherProps
}) => {
  const base = 'mdc-top-app-bar';
  const suffix = '-fixed-adjust';
  const classes = classnames(className, {
    [base + '--short' + suffix]: short,
    [base + '--dense' + suffix]: dense && !prominent,
    [base + '--dense-prominent' + suffix]: dense && prominent,
    [base + '--prominent' + suffix]: !dense && prominent,
    [base + '-' + suffix]: !short && !dense && !prominent,
  });

  return (
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/26635
    // @ts-ignore
    <Tag className={classes} {...otherProps}>
      {children}
    </Tag>
  );
};

export default FixedAdjust;
